import "./Hero01.css";
import img1 from "./../../../img/instagram/ss-1.jpg";
import img2 from "./../../../img/instagram/ss-2.jpg";
import img3 from "./../../../img/instagram/ss-3.jpg";
import img4 from "./../../../img/instagram/ss-4.jpg";
import img5 from "./../../../img/instagram/ss-5.jpg";

function Hero01() {
  return (
    <div className="Hero01 section" id="Hero01">
      <div className="container">
        <div className="Hero01-box">
          <h1>Setting the Royal Standard in Barbering.</h1>

          <p>
            Book your appointment for a modern cut, classic shave, or the VIP
            experience.
          </p>

          <a href="/book-now" className="btn-3">
            BOOK NOW
          </a>
        </div>
      </div>

      <div className="Hero01-gallery">
        <div className="Hero01-gallery-slider">
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
          <img src={img5} alt="" />
        </div>

        <div className="Hero01-gallery-slider">
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
          <img src={img5} alt="" />
        </div>

        <div className="Hero01-gallery-slider">
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
          <img src={img5} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Hero01;
